export interface ColumnSplit {
  leftSpan: number;
  rightSpan: number;
}

const MIN_SPAN = 1;
const MAX_SPAN = 12;

// Dragging the handle between two adjacent blocks in a 12-column grid row
// only ever trades columns between them — the row's total span never
// changes. Clamped so neither side can shrink below one column or exceed
// what the pair has to give.
export function clampSplit(leftSpan: number, rightSpan: number, deltaColumns: number): ColumnSplit {
  const total = leftSpan + rightSpan;
  const minLeft = MIN_SPAN;
  const maxLeft = Math.min(MAX_SPAN, total - MIN_SPAN);

  const nextLeft = Math.min(maxLeft, Math.max(minLeft, leftSpan + deltaColumns));
  return { leftSpan: nextLeft, rightSpan: total - nextLeft };
}
